
import styled from "styled-components";
import MiniLoader from "../../../utils/MIniLoader";
import { useReportContext } from "../../../context/report_context";


const TopSellingProduct = ({ storeTopSell }) => {

      const { isFetching } = useReportContext();

      return (
            <StyledTopSellingProduct className="h-100">
                  <div className="main-container">
                        <div className="justify-content-between row">

                              <div className="d-flex gap-2">
                                    <h4 className="grey-bold-text">
                                          Top Selling Product
                                    </h4>
                                    <MiniLoader
                                          load={isFetching}
                                    />
                              </div>
                        </div>


                        <div className="light-bg br-md">

                              <div className="table-responsive">
                                    <table className='table p-2 border-0 text-center text-nowrap br-md fs-6' >
                                          <thead>
                                                <tr className=''>
                                                      <th scope="col" className='text-start grey-text'>
                                                            Product
                                                      </th>
                                                      <th scope="col" className='text-start grey-text'>
                                                            Product ID
                                                      </th>
                                                      <th scope="col" className='grey-text'>
                                                            Quantity
                                                      </th>
                                                </tr>
                                          </thead>

                                          <tbody>
                                                {storeTopSell && storeTopSell.length > 0 ? (
                                                      storeTopSell?.map(({ item_id, itemsData, qty }, i) => {
                                                            const { item = "" } = itemsData;
                                                            return (
                                                                  <tr className='py-2' key={i}>
                                                                        <td className="text-start">{item}</td>
                                                                        <td>{item_id}</td>
                                                                        <td>{qty}</td>
                                                                  </tr>
                                                            );
                                                      })
                                                ) : (
                                                      <tr>
                                                            <td colSpan={3} className="py-4 text-center">
                                                                  No items
                                                            </td>
                                                      </tr>
                                                )}

                                          </tbody>
                                    </table>
                              </div>
                        </div>
                  </div>


            </StyledTopSellingProduct>
      );
};

export default TopSellingProduct;

const StyledTopSellingProduct = styled.div`
      

      input.month-input {
            border-radius: 0px !important;
            padding: 4px 4px;
            border-color: #a8a5a5;
      }


`;